export const VITE_BASE_URL = import.meta.env.VITE_BASE_URL;
export const VITE_KEYCLOAK_URL = import.meta.env.VITE_KEYCLOAK_URL;
export const VITE_KEYCLOAK_REALM = import.meta.env.VITE_KEYCLOAK_REALM;
export const VITE_KEYCLOAK_CLIENT = import.meta.env.VITE_KEYCLOAK_CLIENT;
export const VITE_FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL;
export const VITE_FIREBASE_API_KEY = import.meta.env.VITE_FIREBASE_API_KEY;
export const VITE_FIREBASE_AUTH_DOMAIN = import.meta.env
  .VITE_FIREBASE_AUTH_DOMAIN;
export const VITE_FIREBASE_PROJECT_ID = import.meta.env
  .VITE_FIREBASE_PROJECT_ID;
export const VITE_FIREBASE_STORAGE_BUCKET = import.meta.env
  .VITE_FIREBASE_STORAGE_BUCKET;
export const VITE_FIREBASE_MESSAGING_SENDER_ID = import.meta.env
  .VITE_FIREBASE_MESSAGING_SENDER_ID;
export const VITE_FIREBASE_APP_ID = import.meta.env.VITE_FIREBASE_APP_ID;
export const VITE_FIREBASE_VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY;
export const VITE_ANNOTABLE_KEY = import.meta.env.VITE_ANNOTABLE_KEY;
export const VITE_STRIPE_PUBLISHABLE_KEY = import.meta.env
  .VITE_STRIPE_PUBLISHABLE_KEY;
export const VITE_JITSI_URL = import.meta.env.VITE_JITSI_URL;
export const VITE_CHILD_SCHEDULE_PDF = import.meta.env.VITE_CHILD_SCHEDULE_PDF;
export const VITE_ADULT_SCHEDULE_PDF = import.meta.env.VITE_ADULT_SCHEDULE_PDF;
export const VITE_PATIENT_ENROLLMENT_DASHBOARD_KEYS = import.meta.env
  .VITE_PATIENT_ENROLLMENT_DASHBOARD_KEYS;
export const VITE_SUPERSET_URL = import.meta.env.VITE_SUPERSET_URL;
export const VITE_GOOGLE_MAPS_API_KEY = import.meta.env
  .VITE_GOOGLE_MAPS_API_KEY;
